
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Combien coûte vraiment la création d’un site Internet en 2026 ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Combien coûte la création d’un site Internet professionnel ? À qui en confier la réalisation ? Cet article vous explique tout !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Combien coûte vraiment la création d’un site Internet en 2026 ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Combien coûte la création d’un site Internet professionnel ? À qui en confier la réalisation ? Cet article vous explique tout !",
        },
      ],
    };
  },
};
